var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"outlined":"","tile":""}},[_c('v-row',{staticClass:"pt-5"},[_c('v-col',{attrs:{"cols":"12"}},[_c('apex-chart-card',{attrs:{"series":_vm.series,"options":_vm.appChart.chartOptions.options}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }